module.exports = __webpack_public_path__ + "img/promo-2.3dd9c344.png";